import ForWhomSection from './Component';

export default ForWhomSection;